module.exports = "pegasus/assets/two-row-image-text-preview.png";